import { ParamMap } from '@angular/router';
import { OrigemCadastroProdutoEnum } from '../enums/produto/origem-cadastro-produto.enum';

/**
 * Rota do cadastro de produto pré-preenchido a partir de um item de origem. Quem abre a tela
 * (compra, associação de itens da NF-e) monta a URL por aqui; a tela lê com `lerOrigemCadastroProduto`.
 */
export function montarUrlCadastroProduto(origem: OrigemCadastroProdutoEnum, idOrigem: number): string {
  return `/cadastros/produtos/cadastrar?origem=${origem}&idOrigem=${idOrigem}`;
}

/**
 * Lê `origem` e `idOrigem` da query. Só é válido com os dois parâmetros, origem conhecida e id
 * inteiro positivo; qualquer outra combinação devolve `null` e a tela abre em branco.
 */
export function lerOrigemCadastroProduto(
  queryParamMap: ParamMap
): { origem: OrigemCadastroProdutoEnum; idOrigem: number } | null {
  const origemParametro = queryParamMap.get('origem');
  const idOrigemParametro = queryParamMap.get('idOrigem');
  if (!origemParametro || !idOrigemParametro) return null;

  const origem = Number(origemParametro);
  const idOrigem = Number(idOrigemParametro);
  const origemConhecida =
    origem === OrigemCadastroProdutoEnum.CompraItem || origem === OrigemCadastroProdutoEnum.NFeEntradaItem;
  if (!origemConhecida || !Number.isSafeInteger(idOrigem) || idOrigem <= 0) return null;

  return { origem, idOrigem };
}
